import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import {
  ARCHIVE_BLOCKED_ACTION_PATTERNS,
  ARCHIVE_MODE_ENABLED,
} from "./archiveConfig";

const CLICKABLE_SELECTOR = [
  "button",
  "a",
  "[role='button']",
  ".p-button",
  ".chakra-button",
].join(",");

function shouldBlockElement(element) {
  const text = (element.textContent || "").trim();

  if (!text) {
    return false;
  }

  if (
    element.closest("[data-archive-navigation]") ||
    element.closest("header") ||
    element.closest("nav")
  ) {
    return false;
  }

  return ARCHIVE_BLOCKED_ACTION_PATTERNS.some((pattern) => pattern.test(text));
}

function disableElement(element) {
  if (element.dataset.archiveBlocked === "true") {
    return;
  }

  element.dataset.archiveBlocked = "true";
  element.style.pointerEvents = "none";
  element.style.opacity = "0.45";
  element.style.cursor = "not-allowed";
  element.setAttribute("title", "Archive mode aktif: bu aksiyon kapalı.");

  if ("disabled" in element) {
    element.disabled = true;
  }
}

function applyArchiveActionLock() {
  document.querySelectorAll(CLICKABLE_SELECTOR).forEach((element) => {
    if (shouldBlockElement(element)) {
      disableElement(element);
    }
  });
}

export default function ArchiveActionGate() {
  const location = useLocation();

  useEffect(() => {
    if (!ARCHIVE_MODE_ENABLED || location.pathname === "/") {
      return undefined;
    }

    applyArchiveActionLock();

    const observer = new MutationObserver(() => {
      applyArchiveActionLock();
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true,
    });

    return () => observer.disconnect();
  }, [location.pathname]);

  return null;
}
